import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: 'https://dev.familiessetfree.net/api', // Replace with your API base URL
});

// Function to set the Authorization header

export default axiosInstance;
